$ = require 'jquery'
_ = require 'underscore'
audienceDefinitions = require 'lib/experiments/audience-definitions'
Auth = require 'db/auth'
md5 = require 'lib/md5'
makeErrorEnum = require 'lib/make-error-enum'
trackExperiment = require 'debug/trackExperiment'

SimpleTestError = makeErrorEnum 'SimpleTest', [
  'InvalidExperimentName'
  'InvalidExperimentAllocation'
]

# These tests have already started running with the old bucketing method,
# so we can't change them now but we don't want any new tests to use this
# method.
V1_EXPERIMENTS = [
  'npsSurveyV3'
  'powerUpRequestCTAV2'
  'teamMemberTabLayoutV1'
]

testCache = {}
BUCKETS = 1000

getHashedId = (id, salt) ->
  if salt
    id += salt
  return parseInt(md5(id).slice(0, 8), 16)

variationsAndControl = ({ defaultWeight, variations }) ->
  [{
    name: 'control',
    weight: defaultWeight ?= 1
  }]
  .concat(variations)

selectNamed = (test, name) ->
  _.find( variationsAndControl(test), name: name )

getWeightedVariations = (test) ->
  variations = variationsAndControl(test)
  weightedVariations = variations
  .filter (variation) ->
    variation.weight > 0
  .reduce (memo, variation) ->
    variation.cumlWeight = variation.weight + if _.last(memo)?
      _.last(memo).cumlWeight
    else
      0
    memo.concat variation
  , []

  weightedVariations

checkAudiences = ({ audiences }) ->
  if !audiences
    return true
  audiences.some (audience) -> audienceDefinitions[audience]()

getExperimentAllocation = (test) ->
  allocation = test.experimentAllocation
  if _.isNumber(allocation)
    allocation
  else
    _.chain(allocation)
    .pairs()
    .map ([audience, allocation]) =>
      if audienceDefinitions[audience]()
        allocation
      else
        0
    .max()
    .value()

collapseTest = ({ test, selectedVariation, identifier }) ->
  {
    track: ->
      trackExperiment test.name + test.experimentVersion, selectedVariation?.name, identifier
    inExperiment: selectedVariation?
    get: (name) ->
      if name == 'variation'
        selectedVariation?.name ? 'control'
      else if selectedVariation?.values?.hasOwnProperty(name)
        selectedVariation.values[name]
      else if test.defaults?.hasOwnProperty(name)
        test.defaults[name]
      else
        return null
  }

inExperiment = (test, identifier) ->
  inExperimentBucket = getHashedId(test.name + test.experimentVersion, 'in' + identifier) % BUCKETS
  inExperimentBucket <= getExperimentAllocation(test) * BUCKETS

getSelectedVariation = {
  v1: (test, identifier) ->
    variations = getWeightedVariations test
    # In order to limit the % of traffic that sees the experiment, as well as bucket into a specific variation we're going
    # to create buckets from 0 - (sum of variation weights / percent of traffic that will see the experiment) * 100
    # the member will be assigned randomly into one of those buckets. if the bucket # is higher than (the # of buckets * traffic allocation percentage),
    # the member will not see the experiment at all. The remaining buckets will be divided based on the variation weights specified in the test configuration

    # The total number of buckets
    dynamicBuckets = Math.floor((_.last(variations).cumlWeight / getExperimentAllocation(test)) * 100)
    # The bucket for this member
    bucket = getHashedId( test.name  + test.experimentVersion, identifier ) % dynamicBuckets

    selectedVariation = _.find variations, (variation) ->
      variation.cumlWeight * 100 >= bucket

    selectedVariation

  v2: (test, identifier) ->
    weightedVariations = getWeightedVariations test

    if inExperiment(test, identifier)
      variationBucket = getHashedId(test.name + test.experimentVersion, 'variation' + identifier) % BUCKETS
      maxWeight = _.last(weightedVariations).cumlWeight
      selectedVariation = _.find weightedVariations, (variation) ->
        (variation.cumlWeight / maxWeight) * BUCKETS >= variationBucket
      return selectedVariation

    return undefined
}

getParams = (testName, identifier) ->
  test = window.abTests?[testName]

  if !test
    throw SimpleTestError.InvalidExperimentName()

  test.name ?= testName
  test.experimentVersion = test.experimentVersion?.toUpperCase() ? ''
  test.experimentAllocation ?= 1

  if _.isNumber(test.experimentAllocation)
    if test.experimentAllocation > 1 or test.experimentAllocation < 0
      throw SimpleTestError.InvalidExperimentAllocation()
  else if _.isObject(test.experimentAllocation)
    if _.any(_.values(test.experimentAllocation), (value) => !(value >= 0 && value <= 1))
      throw SimpleTestError.InvalidExperimentAllocation()

  # Check the cookies for a force_<experiment> cookie, with the value being the variation to run.
  # e.g. document.cookie='force_inlinePowerUpV1=inlineText''
  override = $.cookie('force_' + test.name)

  bucketVersion = if test.name + test.experimentVersion in V1_EXPERIMENTS
      'v1'
    else
      'v2'

  selectedVariation =
    if override
      selectNamed(test, override)
    else if checkAudiences(test)
      getSelectedVariation[bucketVersion](test, identifier)
  collapsedTest = collapseTest { test, selectedVariation, identifier }

  if selectedVariation? && test.autoTrack == true
    collapsedTest.track()

  return collapsedTest

module.exports = (testName, identifier) ->
  # Default the identifier to the member ID
  identifier = identifier ? Auth.me().id
  key = _.compact([testName, identifier]).join(':')
  testCache[key] ?= getParams(testName, identifier)



// WEBPACK FOOTER //
// ./app/scripts/lib/experiments/simple-test.coffee